const validate = (value, {target}) => {
    if (Array.isArray(value)) {
        return value.every(val => validate(val, {target}))
    }

    return String(value).endsWith(target)
}

export default validate
